/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

import { UserProfile } from '@totem/types/user';

export interface Context {
  refetch: () => void;
  refreshToken: () => void;
  setProfile: (userProfile: UserProfile) => void;
  setProfileAndToken: (
    userProfile: UserProfile,
    token: string,
    source: string,
  ) => void;
  loading: boolean;
  userProfile: UserProfile;
  showTooltips: boolean;
  setShowTooltips: (showTooltips: boolean) => void;
  getApiToken: () => string;
  getSoftApiToken: () => string;
  setApiToken: (token: string, source: string) => void;
  setTokenTTL: (ttl: number) => void;
  tokenTTL: number;
  tokenRefreshCount: number;
  mainMenuLocation: string;
  preferredTheme: string;
}

export const initialState: Context = {
  refetch: () => {},
  refreshToken: () => {},
  setProfile: () => {},
  setProfileAndToken: () => {},
  loading: true,
  // @ts-ignore
  userProfile: {},
  showTooltips: false,
  setShowTooltips: (showTooltips: boolean) => {},
  setApiToken: () => {},
  getApiToken: () => {
    return '';
  },
  getSoftApiToken: () => {
    return '';
  },
  setTokenTTL: () => {},
  mainMenuLocation: 'Left',
  preferredTheme: 'light',
};

const UserProfileContext = React.createContext<Context>(initialState);

export default UserProfileContext;
